import React from 'react';

import { Box, Flex } from '@adsk/alloy-react-box';
import theme from '@adsk/alloy-react-theme';
import { OverflowTooltip } from '@adsk/alloy-react-tooltip';

import getPluginKey from './helpers/getPluginKey';
import { CommonReferencePickerPlugin } from './types/ReferencePickerPlugin';

interface TypeButtonLabelProps {
  plugin: CommonReferencePickerPlugin;
  disabled?: boolean;
  showIcon?: boolean;
}

const TypeButtonLabel: React.FC<TypeButtonLabelProps> = ({
  plugin,
  disabled,
  showIcon = true,
}) => {
  const { CustomOptionLabel } = plugin;
  const OptionLabel = CustomOptionLabel || plugin.PluralText;

  return (
    <Flex
      alignItems="center"
      {...(!disabled && {
        color: 'charcoal900',
      })}
      data-testid={`TypeButtonLabel--${getPluginKey(plugin)}`}
    >
      {showIcon &&
        plugin.renderIcon?.({
          style: {
            ...(!disabled && {
              color: theme.colors.charcoal700,
            }),
            marginRight: 10,
          },
        })}
      <Box>
        <OverflowTooltip>
          <OptionLabel />
        </OverflowTooltip>
      </Box>
    </Flex>
  );
};

export default TypeButtonLabel;
